export function getPatientFullName(firstName: string, lastName: string): string {
    return [firstName, lastName].filter((name) => name !== undefined && name !== null && name !== "").join(" ")
}

export function getPatientFullNameOrId(firstName: string, lastName: string, customId: string): string {
    const fullName = getPatientFullName(firstName, lastName)

    return fullName !== "" ? fullName : customId
}
